import {
  Backdrop, Button, Card, CardActions, CardHeader, CardMedia, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, FormControl, Grid, Input, InputAdornment, LinearProgress, MenuItem, Select, Slide, Slider, Snackbar, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tabs, TextField, Typography
} from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AdjustIcon from '@material-ui/icons/Adjust';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import LockIcon from '@material-ui/icons/Lock';
import QueueIcon from '@material-ui/icons/Queue';
import MuiAlert from '@material-ui/lab/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import SearchBar from "material-ui-search-bar";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { GetLocalMaterialSearch, getSepetAdet, getUser, GetWarehouseAddress, sc, SetLocalMaterialSearch, setSepetAdet } from 'src/utils/Common';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  Tab: {
    minWidth: 113

  },
  tableleft: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 300,
    minHeight: 300,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }

  },
  tablecenter: {
    maxWidth: 800
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  selectMargin: {
    marginTop: theme.spacing(2)
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
  },
  ustBolum: {
    maxHeight: 450,
    minHeight: 450,
    width: '100%'
  },
  cardUstBolum: {
    maxHeight: 448,
    minHeight: 448,
    width: '100%'
  },
  altBolum: {
    maxHeight: 350,
    minHeight: 350,
    width: '100%'
  },
  cardAltBolum: {
    maxHeight: 348,
    minHeight: 348,
    width: '100%'
  },
  button: {
    margin: theme.spacing(0.2),
  },
  cardScrollTabUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 350,
    minHeight: 350,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 0px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 0px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
  cardScrollUst: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 300,
    minHeight: 300,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
  cardScrollUstMuadil: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 450,
    minHeight: 450,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
  cardScroll: {
    overflowY: "auto",
    margin: 0,
    padding: 0,
    maxHeight: 348,
    minHeight: 348,
    listStyle: "none",
    height: "100%",
    '&::-webkit-scrollbar': {
      width: '0.4em'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '0px solid slategrey'
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  tableSelected: {
    backgroundColor: '#FFFFDF',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function MaterialSearch() {
  const classes = useStyles();
  const user = getUser();
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [Loading, setLoading] = React.useState(false);
  const [MalzemeArama, setMalzemeArama] = React.useState("");
  const [MaterialLeftData, setMaterialLeftData] = React.useState([]);
  const [ImageUrl, setImageUrl] = useState(null)
  const [ImageUrlMuadil, setImageUrlMuadil] = useState(null)
  const [bultenParam, setbultenParam] = useState("")
  const [MaterialActionData, setMaterialActionData] = useState([]);
  const [MaterialActionMainData, setMaterialActionMainData] = useState([]);
  const [FisMalzemeMainData, setFisMalzemeMainData] = useState([]);
  const [FisMalzemeData, setFisMalzemeData] = useState([]);
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [openAddressDialog, setopenAddressDialog] = React.useState(false);
  const [AdetDegistir, setAdetDegistir] = React.useState(false);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [MuadilMalzemeData, setMuadilMalzemeData] = useState([]);
  const [MuadilMalzemeMainData, setMuadilMalzemeMainData] = useState([]);
  const [MalzemeCikisData, setMalzemeCikisData] = useState([]);
  const [TeknisyenZimmet, setTeknisyenZimmet] = useState([]);
  const [MalzemeCikisMainData, setMalzemeCikisMainData] = useState([]);
  const [MalzemeAdresData, setMalzemeAdresData] = useState([]);
  const [MalzemeAdresMainData, setMalzemeAdresMainData] = useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [MalzemeHeader, setMalzemeHeader] = useState("Malzeme Detayı");
  const [MuadilSearch, setMuadilSearch] = React.useState("");
  const [MalzemeHareketSearch, setMalzemeHareketSearch] = React.useState("");
  const [MalzemeDetaySearch, setMalzemeDetaySearch] = React.useState("");
  const [MalzemeSiparisSearch, setMalzemeSiparisSearch] = React.useState("");
  const [MalzemeSiparisAramaYap, setMalzemeSiparisAramaYap] = React.useState("");
  const [MalzemeSiparisMainData, setMalzemeSiparisMainData] = useState([]);
  const [MalzemeSiparisData, setMalzemeSiparisData] = useState([]);
  const [MalzemeStokData, setMalzemeStokData] = useState({});
  const [selectedRow, setselectedRow] = useState(-1);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [Address, setAddress] = React.useState("");
  const [EskiAdresId, setEskiAdresId] = React.useState("");
  const defaultUyari = { open: false, aciklama: '', tip: 'success' };
  const [uyari, setUyari] = useState(defaultUyari);
  const [MalzemeAramaParam, setMalzemeAramaParam] = React.useState('Malzeme');
  const [value, setValue] = React.useState(null);
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState("");
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState("");
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [dataPaslasma, setdataPaslasma] = React.useState([]);
  const [PaslasmaAdet, setPaslasmaAdet] = React.useState(0);
  const [TopMalzemeHeader, setTopMalzemeHeader] = React.useState("");
  const [MalzemeKDVliFiyat, setMalzemeKDVliFiyat] = React.useState(0.00);
  const [PaslasmaKontrol, setPaslasmaKontrol] = React.useState(false);
  const [curRow, setCurRow] =React.useState({});

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      SolMenuTekrarSorgula();
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, []);



  const SolMenuTekrarSorgula = () => {
    var DegerMaterialSearch = [];
    DegerMaterialSearch = GetLocalMaterialSearch();

    if (DegerMaterialSearch === null) {
      setMaterialLeftData([]);
    } else {
      setMaterialLeftData(DegerMaterialSearch);
      var MalzemeYenile = "";
      DegerMaterialSearch.forEach(i => {
        MalzemeYenile += i.MALZEME_STOK_NO.toString().replace(" ", "") + ",";
      });

      setLoading(true);
      axios.get(`MaterialSearchDetail/${MalzemeYenile}/${"Malzeme"}/${user.ServiceShopId}`)
        .then(response => {
          var DegerTmp = [];
          DegerTmp = response.data;

          if (DegerTmp[0].ErrorCode === "0") {
            DegerTmp.map(i => {
              i.SIRALAMA = DegerMaterialSearch.find(a => a.MALZEME_KODU == i.MALZEME_KODU).SIRALAMA || 0
            })
            setMaterialLeftData(DegerTmp);
            SetLocalMaterialSearch(DegerTmp);
          } else {
            if (parseInt(DegerTmp[0].ErrorCode) > 0) {
              setUyari({ open: true, aciklama: DegerTmp[0].ErrorDescription, tip: 'error' });
            }
          }

          setLoading(false);
        }).catch(error => {
          setLoading(false);
        });

    }
  }

  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleInputChange = (event) => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };
  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };

  const [Tabvalue, setTabvalue] = React.useState(0);
  const GetMaterialLeftSearch = () => {
    setLoading(true);
    axios.get(`MaterialSearchDetail/${MalzemeArama}/${MalzemeAramaParam}/${user.ServiceShopId}`)
      .then(response => {
        var DegerTmp = [];
        DegerTmp = response.data;

        if (DegerTmp[0].ErrorCode === "0") {
          var MaterialLeftDataParam = [...MaterialLeftData];
          var Sira = 0;
          MaterialLeftDataParam.map(i => {
            i.SIRALAMA += 1;
            if (i.MALZEME_KODU == DegerTmp[0].MALZEME_KODU) {
              i.SIRALAMA = 0
            }
          })
          DegerTmp[0].SIRALAMA = 0;
          DegerTmp.forEach(i => {
            var Varmi = MaterialLeftDataParam.filter(d => d.MALZEME_STOK_NO === i.MALZEME_STOK_NO.toString().replace(" ", ""));
            if (Varmi.length === 0) {
              MaterialLeftDataParam.push(DegerTmp[Sira]);
            }
            Sira = Sira + 1;
          });
          setMaterialLeftData(MaterialLeftDataParam);
          SetLocalMaterialSearch(MaterialLeftDataParam);
        } else {
          if (parseInt(DegerTmp[0].ErrorCode) > 0) {
            setUyari({ open: true, aciklama: DegerTmp[0].ErrorDescription, tip: 'error' });
          }
        }

        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const SetSearchClear = (event) => {
    setMaterialLeftData([]);
    setMalzemeArama("");
    SetLocalMaterialSearch([]);
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const handleCloseAddressDialog = () => {
    setopenAddressDialog(false);
  };

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrlMuadil(fileURL);
        setLoadingMaterial(false);
      }).catch(error => {
        setLoadingMaterial(false);
      });
  }

  const GetFisMalzeme = (MALZEME_STOK_NO) => {

    axios.get("GetFisMalzeme/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setFisMalzemeMainData(response.data);
        setFisMalzemeData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  const GetMalzemeCikisHareket = (MALZEME_STOK_NO) => {
    axios.get("GetMalzemeCikisHareket/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMalzemeCikisMainData(response.data);
        setMalzemeCikisData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const GetTeknisyenZimmetHareket = (MALZEME_STOK_NO) => {
    axios.get("GetTeknisyenZimmetHareket/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setTeknisyenZimmet(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const GetMalzemeGirisHareket = (MALZEME_STOK_NO) => {
    axios.get("GetMalzemeGirisHareket/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMaterialActionMainData(response.data);
        setMaterialActionData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };
  const GetMalzemeSiparisListe = (MALZEME_STOK_NO) => {

    axios.get("GetMalzemeSiparisListe/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMalzemeSiparisMainData(response.data);
        setMalzemeSiparisData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const GetMalzemeStokDurumu = (MALZEME_STOK_NO) => {

    axios.get("GetMaterialInfo/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMalzemeStokData(response.data);
        var Merkez = 1;
        var Servis = 1;
        var Bolge = 1;

        if (response.data?.MERKEZ === "" || response.data?.MERKEZ === 0) {
          Merkez = 0;
        }
        if (response.data?.BOLGE === "" || response.data?.BOLGE === 0) {
          Servis = 0;
        }
        if (response.data?.SERVIS === "" || response.data?.SERVIS === 0) {
          Bolge = 0;
        }
        if ((Merkez + Servis + Bolge) === 0) {
          setPaslasmaKontrol(true);
          axios.get("GetMaterialPass/" + user.ServiceShopId + "/" + MALZEME_STOK_NO + "/1")
            .then(responsePass => {
              setPaslasmaAdet(responsePass.data.length.toString() + " Serviste Var");
            }).catch(error => {
              setLoading(false);
            });
        }else{
          setPaslasmaKontrol(false);
        }



        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const MalzemeResimGoster = (MALZEME_STOK_NO) => {
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get(`MaterialFile/${MALZEME_STOK_NO}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
      }).catch(error => {
      });

  }
  const MalzemeDetayiGoster = (row, index) => {
    setCurRow(row);
    setbultenParam(row.MALZEME_STOK_NO);
    setAdetDegistir(row.ADET);
    setMalzemeHeader(row.MALZEME_STOK_NO + '-' + row.MALZEME + ' Rezervasyon:' + row.REZERVASYON + ' Zimmet:' + row.ZIMMET + ' Adet:' + row.ADET);
    MalzemeResimGoster(row.MALZEME_STOK_NO);
    GetMalzemeGirisHareket(row.MALZEME_STOK_NO);
    GetFisMalzeme(row.MALZEME_STOK_NO);
    GetMalzemeDepo(row.MALZEME_STOK_NO);
    GetMalzemeSiparisListe(row.MALZEME_STOK_NO);
    GetMalzemeStokDurumu(row.MALZEME_STOK_NO);
    GetMalzemeCikisHareket(row.MALZEME_STOK_NO);
    GetTeknisyenZimmetHareket(row.MALZEME_STOK_NO);
    GetAllOpenPassByMaterial(row.MALZEME_STOK_NO);
    setLoading(true);
    setselectedRow(index);
    setTopMalzemeHeader(row.MALZEME_STOK_NO + '-' + row.MALZEME + ' Detayı');
    setMalzemeKDVliFiyat(row.KDVLI_FIYAT)

    axios.get("GetMaterialEquivalent/" + row.MALZEME_STOK_NO + "/" + user.ServiceShopId)
      .then(response => {
        setMuadilMalzemeMainData(response.data);
        setMuadilMalzemeData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });

    SolMenuTekrarSorgula();

  }

  const GetMalzemeDepo = (MALZEME_STOK_NO) => {

    axios.get("GetMalzemedDepo/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setMalzemeAdresMainData(response.data);
        setMalzemeAdresData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  function GetAllOpenPassByMaterial(MALZEME_STOK_NO) {
    axios.get("GetAllOpenPassByMaterial/" + user.ServiceShopId + "/" + MALZEME_STOK_NO)
      .then(response => {
        setdataPaslasma(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  const AdresSilKabul = (event, ID) => {
    setLoading(true);
    const data = {
      YeniAdres: 0
      , EskiAdres: ID
      , Adet: -100
      , BirimKodu: parseInt(user.ServiceShopId)
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetMaterialAddressChange', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetMalzemeDepo(bultenParam);
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }


  const AdresSil = (event, ID) => {
    confirmAlert({
      message:
        'Bu malzeme için bu adresi silmek istediğinizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            AdresSilKabul(event, ID);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }

  const SetAddressChange = (event, ID, ADET) => {

    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(user.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
    setEskiAdresId(ID);
    setAdetDegistir(ADET);
    setopenAddressDialog(true);
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  const MuadilAramaYap = (Search) => {
    // MuadilMalzemeData
    setMuadilSearch(Search);
    setMuadilMalzemeData(MuadilMalzemeMainData.filter(item => sc(item.AKTIF_MUADIL, Search) || sc(item.TIP, Search)))

  }
  const MalzemeFisAramaYap = (Search) => {
    setFisMalzemeData(FisMalzemeMainData.filter(item => sc(item.FIS_NO, Search) || sc(item.DURUM, Search)
      || sc(item.KUL_TEK_KODU, Search)
      || sc(item.ADI, Search)
      || sc(item.SOYADI, Search)
      || sc(item.RANDEVU_TARIHI, Search)
    ))
  }
  const MalzemeGirisHareketAramaYap = (Search) => {
    setMaterialActionData(MaterialActionMainData.filter(item =>
      sc(item.TARIH, Search)
      || sc(item.TIP, Search)
      || sc(item.KULLANICI, Search)
      || sc(item.FATURA_NO, Search)
      || sc(item.ADET, Search)
    ))
  }
  const MalzemeCikisHareketAramaYap = (Search) => {
    setMalzemeCikisData(MalzemeCikisMainData.filter(item =>
      sc(item.TARIH, Search)
      || sc(item.TIP, Search)
      || sc(item.KULLANICI, Search)
      || sc(item.TEKNISYEN, Search)
      || sc(item.FATURA_NO, Search)
      || sc(item.ADET, Search)
    ))
  }
  const MalzemeDetayAramaYap = (Search) => {
    setMalzemeAdresData(MalzemeAdresMainData.filter(item =>
      sc(item.DEPO, Search)
      || sc(item.ADRES, Search)
      || sc(item.SIRA, Search)
      || sc(item.KAT, Search)
      || sc(item.RAF, Search)
      || sc(item.KUTU, Search)
    ))
  }
  const MalzemesiparisAramaYap = (Search) => {
    setMalzemeSiparisData(MalzemeSiparisMainData.filter(item =>
      sc(item.ORDERNO, Search)
      || sc(item.SAPNO, Search)
      || sc(item.FISNO, Search)
      || sc(item.OrderItem, Search)
      || sc(item.QTY, Search)
      || sc(item.ORDERDATE, Search)
    ))
  }
  const handleTabChange = (event, newValue) => {
    setTabvalue(newValue);
  };
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function stableSortSiparis(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    if (stabilizedThis === "ORDERDATE") {
      alert("Tarih");
    }

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const headMalzemeFisCells = [
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'FişNo' },
    { id: 'DURUM', numeric: false, disablePadding: true, label: 'Durum' },
    { id: 'KUL_TEK_KODU', numeric: false, disablePadding: true, label: 'Teknisyen' },
    { id: 'RANDEVU_TARIHI', numeric: false, disablePadding: true, label: 'Randevu' },
  ];
  const headMalzemeGirisCells = [
    { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
    { id: 'TIP', numeric: false, disablePadding: true, label: 'Tip' },
    { id: 'KULLANICI', numeric: false, disablePadding: true, label: 'Kullanıcı' },
    { id: 'FATURA_NO', numeric: false, disablePadding: true, label: 'Fatura' },
    { id: 'FATURA_ADET', numeric: true, disablePadding: true, label: 'FaturaAdet' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'GirişAdet' },

  ];
  const headMalzemeCikisCells = [
    { id: 'TARIH', numeric: false, disablePadding: true, label: 'Tarih' },
    { id: 'TIP', numeric: false, disablePadding: true, label: 'Tip' },
    { id: 'KULLANICI', numeric: false, disablePadding: true, label: 'Kullanıcı' },
    { id: 'TEKNISYEN', numeric: false, disablePadding: true, label: 'Teknisyen' },
    { id: 'FATURA_NO', numeric: false, disablePadding: true, label: 'Fatura' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
  ];
  const headMalzemeMuadilCells = [
    { id: '', numeric: false, disablePadding: true, label: '' },
    { id: 'AKTIF_MUADIL', numeric: false, disablePadding: true, label: 'Malzeme' },
    { id: 'TIP', numeric: false, disablePadding: true, label: 'Aktif/Pasif' },
    { id: '', numeric: false, disablePadding: true, label: 'Resim' },
  ];
  const headMalzemeleftDataCells = [
    { id: 'ADET', numeric: false, disablePadding: true, label: 'Sipariş' },
    { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'Malzeme' },
    // { id: 'MALZEME', numeric: false, disablePadding: true, label: 'Malzeme' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'Depoda' },
    { id: 'ZIMMET', numeric: true, disablePadding: true, label: 'Zimmet' },
    { id: 'REZERVASYON', numeric: true, disablePadding: true, label: 'Rzv' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'Sil' },
  ];
  const headMalzemeAdresCells = [
    { id: 'DEPO', numeric: false, disablePadding: true, label: 'Depo' },
    { id: 'ADRES', numeric: false, disablePadding: true, label: 'Adres' },
    { id: 'SIRA', numeric: false, disablePadding: true, label: 'Sıra' },
    { id: 'KAT', numeric: false, disablePadding: true, label: 'Kat' },
    { id: 'RAF', numeric: false, disablePadding: true, label: 'Raf' },
    { id: 'KUTU', numeric: false, disablePadding: true, label: 'Kutu' },
    { id: 'SERBEST_REZERVE', numeric: false, disablePadding: true, label: 'Adet' },
    { id: 'DEGISTIR', numeric: false, disablePadding: true, label: 'Değiştir' },
    { id: 'SIL', numeric: false, disablePadding: true, label: 'Sil' },
  ];
  const headMalzemeSiparisCells = [
    { id: 'ORDERDATE', numeric: false, type: "date", disablePadding: true, label: 'Tarih' },
    { id: 'ORDERNO', numeric: true, disablePadding: true, label: 'No' },
    { id: 'SAPNO', numeric: false, disablePadding: true, label: 'SapNo' },
    { id: 'FATURA_TARIHI', numeric: false, disablePadding: true, label: 'FaturaTarihi' },
    { id: 'FISNO', numeric: true, disablePadding: true, label: 'FişNo' },
    { id: 'KULLANICI', numeric: true, disablePadding: true, label: 'SiparişAçan' },
    { id: 'ITEMNO', numeric: true, disablePadding: true, label: 'Malzeme' },
    { id: 'QTY', numeric: true, disablePadding: true, label: 'Adet' },
    { id: 'PLATFORM', numeric: true, disablePadding: true, label: 'Platform' },
    { id: 'Sil', numeric: false, disablePadding: true, label: 'Sil' }
  ];
  function strToDate(dtStr) {
    if (!dtStr) return null;
    if (dtStr.length < 11) {
      dtStr = dtStr + " 00:00"
    }
    dtStr += ":00" //dtStr -> "06.12.2021 11:39" + ":00"
    let dateParts = dtStr.split(".");
    let timeParts = dateParts[2].split(" ")[1].split(":");
    dateParts[2] = dateParts[2].split(" ")[0];
    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
  }
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {

    if (orderBy === "TARIH" || orderBy === "ORDERDATE") {
      if (strToDate(b[orderBy]) < strToDate(a[orderBy])) {
        return -1;
      }
      if (strToDate(b[orderBy]) > strToDate(a[orderBy])) {
        return 1;
      }
      return 0;
    }
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleRequestSort = (event, property) => {


    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };



  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'center'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  const handleAddressChange = (event) => {
    setLoading(true);
    const data = {
      YeniAdres: Address
      , EskiAdres: EskiAdresId
      , MalzemeStokNo: bultenParam
      , Adet: parseInt(AdetDegistir)
      , BirimKodu: parseInt(user.ServiceShopId)
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    if (parseInt(AdetDegistir) < 1 || AdetDegistir === '' || AdetDegistir === undefined || AdetDegistir === null) {
      setLoading(false);
      setUyari({ open: true, aciklama: "Adet girilmedi!...Lütfen kontrol ediniz!...", tip: 'error' });
      return;
    }
    if (Address === '') {
      setLoading(false);
      setUyari({ open: true, aciklama: "Adres seçimi yapmadınız!...Lütfen Adres seçiniz!...", tip: 'error' });
      return;
    }

    axios.post('/SetMaterialAddressChange', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        setLoading(false);
        GetMalzemeDepo(bultenParam);
        handleCloseAddressDialog();
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }
  const handleMalzemeAramaParamChange = (event) => {
    setMalzemeAramaParam(event.target.value);
  };


  const SepeteEkleDetay = (event) => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: user.ServiceShopId,
      TEKNISYEN_KODU: user.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetMaterialBasket', data, config)
      .then(response => {

        if (response.data[0].ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
        } else {
          setUyari({ open: true, aciklama: response.data[0].ErrorDescription, tip: 'error' });
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  }
  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(MALZEME_STOK_NO + " numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?");
    setopenSiparisAdet(true);
  }
  const GetMaterialBultenArama = (event, MALZEME_STOK_NO) => {
    setMalzemeAramaParam("Malzeme");
    setMalzemeArama(MALZEME_STOK_NO);
    GetMaterialLeftSearch();
  }


  const SorgulamaSil = (event, row, index) => {
    var RowParam = [...MaterialLeftData];
    RowParam.splice(index, 1);
    setMaterialLeftData(RowParam);
    SetLocalMaterialSearch(RowParam);
  }

  const SetMaterialOrderDeleteKabul = (event, row) => {
      setLoading(true);
      const user = getUser();
  
      if (!row.SAPNO || row.SAPNO.trim() === '' || row.Type === 'ST') {
        setUyari({ open: true, aciklama: "Siparişiniz Arçelik sistemlerinde henüz oluşmadığından iptal edemezsiniz !", tip: 'error' });
        if(row.Type === 'ST'){
        setUyari({ open: true, aciklama: "ST tipindeki siparişleri iptal edemezsiniz!", tip: 'error' });
        }
        setLoading(false);
        return;
      }
  
      var OrderItemParam = '1';
      if (row.OrderItem.toString().length == 1) {
        OrderItemParam = '00000' + row.OrderItem.toString();
      } else {
        OrderItemParam = '0000' + row.OrderItem.toString();
      }
  
      axios
        .get(
          `SetOrderDelete/${user.ServiceShopId}/${row.ORDERNO}/${
            user.ServiceShopCode
          }/${row.SAPNO || '0'}/${OrderItemParam}/${row.QTY}/${row.QTY}/${
            user.OrganizationUserId
          }`
        )
        .then(res => {
          setLoading(false);
          setUyari({ open: true, aciklama: res.data, tip: 'success' });
          MalzemeDetayiGoster(curRow, selectedRow);
        })
        .catch(err => {
          setLoading(false);
          setUyari({ open: true, aciklama: 'Silme işleminiz sırasında bir hata oluştu!...', tip: 'error' });
          MalzemeDetayiGoster(curRow, selectedRow);
        });
    };
  
    const SetMaterialOrderDelete = (event, row) => {
      confirmAlert({
        message:
          'Talepte bulunulan ' +
          row.ITEMNO +
          ' malzeme siparişi iptal edilecektir!... Devam etmek istediğinizden emin misiniz?',
        buttons: [
          {
            label: 'Evet',
            onClick: () => {
              SetMaterialOrderDeleteKabul(event, row);
            }
          },
          {
            label: 'Hayır',
            onClick: () => {
              return;
            }
          }
        ]
      });
    };

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={"oasis Yönetimi " + TopMalzemeHeader} />
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Grid container spacing={1}>
            <Grid item xs={12} sm={4} className={classes.ustBolum}>
              <Card className={classes.cardUstBolum}>
                <CardHeader title="Malzeme İşlemleri"
                  action={
                    <DeleteSweepIcon
                      style={{ color: 'red' }}
                      title="Arama Listesini Temizle"
                      onClick={(event) => SetSearchClear(event)}
                    />
                  }
                />
                <Snackbar open={uyari.open} autoHideDuration={6000}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  onClose={uyariKapat}>
                  <Alert onClose={uyariKapat} severity={uyari.tip}>
                    {uyari.aciklama || ''}
                  </Alert>
                </Snackbar>
                <Divider />
                <CardActions>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={9}>
                      <FormControl fullWidth className={classes.margin}>
                        <TextField
                          label={MalzemeAramaParam + ' arama yapınız...'}
                          className={clsx(classes.margin, classes.textField)}
                          value={MalzemeArama}
                          onChange={event => { setMalzemeArama(event.target.value) }}
                          onKeyPress={event => {
                            if (event.key === 'Enter') {
                              GetMaterialLeftSearch()
                            }
                          }}
                          InputProps={{
                            endAdornment:
                              <InputAdornment position="end">
                                <QueueIcon
                                  onClick={(event) => GetMaterialLeftSearch()}
                                  color="primary"
                                />
                              </InputAdornment>,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControl fullWidth className={classes.selectMargin}>
                        <Select
                          value={MalzemeAramaParam}
                          className={clsx(classes.margin, classes.textField)}
                          onChange={handleMalzemeAramaParamChange}
                        >
                          <MenuItem value={'Malzeme'}>Malzeme</MenuItem>
                          <MenuItem value={'Teknisyen'}>Teknisyen</MenuItem>
                          <MenuItem value={'FisNo'}>FişNo</MenuItem>
                          <MenuItem value={'DepoAdres'}>DepoAdres</MenuItem>
                          {/* <MenuItem value={'Urun'}>Ürün</MenuItem>
                          <MenuItem value={'Siparis'}>Sipariş</MenuItem> */}
                          <MenuItem value={'Paslasma'}>Paslaşma</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardActions>
                <TableContainer
                  className={classes.tableleft}
                >
                  <Table
                    stickyHeader
                    size={'small'}>
                    <EnhancedTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      Header={headMalzemeleftDataCells}
                    />
                    <TableBody>
                      {MaterialLeftData.sort((a, b) => a.SIRALAMA - b.SIRALAMA).map((row, index) => (
                        <TableRow key={index}
                          className={selectedRow === index ? classes.tableSelected : ""}
                        >
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.SIP_VERILEBILIR === 0 ?
                              <LockIcon color="error" />
                              :
                              <AddShoppingCartIcon
                                onClick={(event) => SepeteEkle(event, row.MALZEME_STOK_NO)}
                                color="primary"
                              />
                            }
                          </TableCell>
                          <TableCell padding='none' align="center"
                            title={row.MALZEME}
                            onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                            {row.MALZEME_STOK_NO} {row.MALZEME.replace(" ", "").substring(0, 5)}...
                          </TableCell>
                          <TableCell padding='none' align="center" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                            {row.ADET}
                          </TableCell>
                          <TableCell padding='none' align="center" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                            {row.ZIMMET}
                          </TableCell>
                          <TableCell padding='none' align="center" onClick={event => { MalzemeDetayiGoster(row, index) }} className={classes.tableCell}>
                            {row.REZERVASYON}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            <DeleteForeverIcon
                              onClick={(event) => SorgulamaSil(event, row, index)}
                              style={{ color: 'red' }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={12} sm={5} className={classes.UstBolum}>
              <Card className={classes.cardUstBolum}>
                <Tabs value={Tabvalue}
                  textColor="secondary"
                  scrollButtons="on"
                  indicatorColor="primary"
                  variant="scrollable"
                  onChange={handleTabChange}>
                  <Tab className={classes.Tab} label="Stok" />
                  <Tab className={classes.Tab} label="Fİşler" />
                  <Tab className={classes.Tab} label="Sİparİş" />
                  <Tab className={classes.Tab} label="Paslaşma" />
                  <Tab className={classes.Tab} label="Gİrİş" />
                  <Tab className={classes.Tab} label="Çıkış" />
                  <Tab className={classes.Tab} label="Zimmet" />
                </Tabs>
                <TabPanel value={Tabvalue} index={0}>
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Yer</TableCell>
                          <TableCell align="left">Stok Adet</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[{ id: "SERVIS", label: "Servis" }
                          , { id: "BOLGE", label: "Bölge" }
                          , { id: "MERKEZ", label: "Merkez" }
                          , { id: "TEMIN_TARIHI", label: "Temin Tarihi" }].map((m, i) =>
                            <TableRow key={i}>
                              <TableCell align="left" className={classes.tableCell}>
                                {m.label}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCell}>
                                {MalzemeStokData[m.id]}
                              </TableCell>
                            </TableRow>
                          )
                        }
                      </TableBody>
                      {PaslasmaKontrol ?
                        <TableBody>
                          <TableRow>
                            <TableCell align="left" className={classes.tableCell}>
                              Paslasma İmkanı
                            </TableCell>
                            <TableCell align="left" className={classes.tableCell}>
                              {PaslasmaAdet}
                            </TableCell>
                          </TableRow>
                        </TableBody> : ""
                      }

                      <TableBody>
                        <TableRow>
                          <TableCell align="left" className={classes.tableCell}>
                            Kdv'li Fiyat
                          </TableCell>
                          <TableCell align="left" className={classes.tableCell}>
                            {MalzemeKDVliFiyat} ₺
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value={Tabvalue} index={1}>
                  <SearchBar
                    value={MalzemeHareketSearch}
                    placeholder="Arama Yapınız..."
                    onChange={(newValue) => MalzemeFisAramaYap(newValue)}
                  />
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <EnhancedTableHead
                        classes={classes}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        Header={headMalzemeFisCells}
                      />
                      <TableBody>
                        {stableSort(FisMalzemeData, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FIS_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.DURUM}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.KUL_TEK_KODU + ' ' + row.ADI + ' ' + row.SOYADI}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.RANDEVU_TARIHI}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value={Tabvalue} index={2}>
                  <SearchBar
                    value={MalzemeSiparisSearch}
                    placeholder="Arama Yapınız..."
                    onChange={(newValue) => MalzemesiparisAramaYap(newValue)}
                  />
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <EnhancedTableHead
                        classes={classes}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        Header={headMalzemeSiparisCells}
                      />
                      <TableBody>
                        {stableSortSiparis(MalzemeSiparisData, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ORDERDATE}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ORDERNO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.SAPNO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FATURA_TARIHI}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FISNO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.KULLANICI}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ITEMNO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.QTY}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.PLATFORM}
                              </TableCell>
                              <TableCell
                                padding="none"
                                align="left"
                                className={classes.tableCell}
                              >
                                {row.DeleteOrderControl === 0 ? (
                                  ''
                                ) : ((row.Type === 'ST') ? ('') :
                                  (<DeleteForeverIcon
                                    onClick={event =>
                                      SetMaterialOrderDelete(event, row)
                                    }
                                    color="primary"
                                  />)
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value={Tabvalue} index={3}>
                  <TableContainer style={{ height: 250, width: '100%' }}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell padding='none' align="center">Tarih</TableCell>
                          <TableCell padding='none' align="center">PaslaşmaNo</TableCell>
                          <TableCell padding='none' align="center">Durum</TableCell>
                          <TableCell padding='none' align="center">FişNo</TableCell>
                          <TableCell padding='none' align="center">Kullanıcı</TableCell>
                          <TableCell padding='none' align="center">PasServis</TableCell>
                          <TableCell padding='none' align="center">GönderiTip</TableCell>
                          <TableCell padding='none' align="center">KargoNo</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stableSort(dataPaslasma, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" >
                                {row.TARIH}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.PASLASMA_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.DURUM}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.FIS_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.TALEP_KULLANICI}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.ARZ_SERVIS}
                              </TableCell>

                              <TableCell padding='none' align="center" >
                                {row.GONDERI_TIP}
                              </TableCell>
                              <TableCell padding='none' align="center" >
                                {row.GONDERI_NO}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>.
                </TabPanel>
                <TabPanel value={Tabvalue} index={4}>
                  <SearchBar
                    value={MalzemeHareketSearch}
                    placeholder="Arama Yapınız..."
                    onChange={(newValue) => MalzemeGirisHareketAramaYap(newValue)}
                  />
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <EnhancedTableHead
                        classes={classes}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        Header={headMalzemeGirisCells}
                      />
                      <TableBody>
                        {stableSort(MaterialActionData, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TARIH}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TIP}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.KULLANICI}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FATURA_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FATURA_ADET}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ADET}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value={Tabvalue} index={5}>
                  <SearchBar
                    value={MalzemeHareketSearch}
                    placeholder="Arama Yapınız..."
                    onChange={(newValue) => MalzemeCikisHareketAramaYap(newValue)}
                  />
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <EnhancedTableHead
                        classes={classes}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        Header={headMalzemeCikisCells}
                      />
                      <TableBody>
                        {stableSort(MalzemeCikisData, getComparator(order, orderBy))
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TARIH}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TIP}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.KULLANICI}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TEKNISYEN}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.FATURA_NO}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ADET}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value={Tabvalue} index={6}>
                  <TableContainer style={{ width: '100%' }} className={classes.cardScrollUst}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}>
                      <TableHead>
                        <TableRow>
                          <TableCell padding='none' align="center">Teknisyen</TableCell>
                          <TableCell padding='none' align="center">Zimmet Adet</TableCell>
                          <TableCell padding='none' align="center">Tarih</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {TeknisyenZimmet
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TEKNISYEN}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.ADET}
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                {row.TARIH}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
              </Card>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.ustBolum}>
              <Card className={classes.cardScrollUstMuadil}>
                <CardHeader title="Muadil" />
                <Divider />
                <SearchBar
                  value={MuadilSearch}
                  placeholder="Arama Yapınız..."
                  onChange={(newValue) => MuadilAramaYap(newValue)}
                />
                <TableContainer style={{ width: '100%' }}>
                  <Table
                    stickyHeader
                    aria-labelledby="tableTitle"
                    size={'small'}>
                    <TableHead>
                      <TableRow>
                        <TableCell padding='none' align="center">Sipariş</TableCell>
                        <TableCell padding='none' align="center">Malzeme</TableCell>
                        <TableCell padding='none' align="center">SerbestStok</TableCell>
                        <TableCell padding='none' align="center">İşlem</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stableSort(MuadilMalzemeData, getComparator(order, orderBy))
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell padding='none' align="center" className={classes.tableCell}>
                              {
                                row.TIP === 'Pasif' ? <LockIcon style={{ color: 'red' }} /> : <AddShoppingCartIcon
                                  onClick={(event) => SepeteEkle(event, row.AKTIF_MUADIL)}
                                  color="primary"
                                />
                              }
                            </TableCell>
                            <TableCell padding='none' align="center" title={row.AKTIF_ACIKLAMA}
                              onClick={(event) => GetMaterialBultenArama(event, row.AKTIF_MUADIL.replace(/^0+/, ''))}
                              className={classes.tableCell}>
                              {row.AKTIF_MUADIL} {row.AKTIF_ACIKLAMA.replace(" ", "").substring(0, 25)}...
                            </TableCell>
                            <TableCell padding='none' align="center" className={classes.tableCell}>
                              {
                                parseInt(row.SERBEST_STOK) > 0
                                  ? <Typography><AdjustIcon title={row.SERBEST_STOK} style={{ color: 'green' }} />{row.SERBEST_STOK}</Typography>
                                  : <Typography><AdjustIcon title={row.SERBEST_STOK} style={{ color: 'red' }}></AdjustIcon>{row.SERBEST_STOK}</Typography>
                              }
                              {

                              }
                            </TableCell>
                            <TableCell padding='none' align="center" className={classes.tableCell}>
                              <ImageSearchIcon
                                onClick={(event) => GetMaterialImage(event, row.AKTIF_MUADIL.replace(/^0+/, ''))}
                                color="primary"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4} className={classes.altBolum}>
              <Card className={classes.cardAltBolum}>
                <CardHeader title="Malzeme Resmi"
                  action={
                    <ImageSearchIcon
                      color="primary"
                      onClick={(event) => GetMaterialImage(event, bultenParam)}
                    />
                  }
                />
                <Divider />
                <CardMedia title="Malzeme Resmi" style={{ height: 348, overflow: 'hidden' }}>
                  <img
                    src={ImageUrl}
                    alt="Malzeme Resmi"
                    style={{ width: '100%', objectFit: 'cover' }}
                  />
                </CardMedia>
              </Card>
            </Grid>
            <Grid item xs={12} sm={5} className={classes.altBolum}>
              <Card className={classes.cardAltBolum}>
                <CardHeader title="Malzeme Adres" />
                <Divider />
                <SearchBar
                  value={MalzemeDetaySearch}
                  placeholder="Arama Yapınız..."
                  onChange={(newValue) => MalzemeDetayAramaYap(newValue)}
                // onRequestSearch={() => doSomethingWith(this.state.value)}
                />
                <TableContainer style={{ width: '1500px' }} className={classes.cardScrollAlt}>
                  <Table
                    stickyHeader
                    className={classes.tablecenter}
                    aria-labelledby="tableTitle"
                    scrollButtons="on"
                    indicatorColor="primary"
                    variant="scrollable"
                    size={'small'}>

                    <EnhancedTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      Header={headMalzemeAdresCells}
                    />
                    <TableBody>
                      {MalzemeAdresData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding='none' align="center" title={row.AKTIF_ACIKLAMA} className={classes.tableCell}>
                            {row.DEPO}
                          </TableCell>
                          <TableCell padding='none' align="center" title={row.AKTIF_ACIKLAMA} className={classes.tableCell}>
                            {row.ADRES}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.SIRA}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.KAT}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.RAF}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.KUTU}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            {row.SERBEST_REZERVE}
                          </TableCell>
                          <TableCell padding='none' align="center" className={classes.tableCell}>
                            <FindReplaceIcon
                              onClick={(event) => SetAddressChange(event, row.ID, row.SERBEST_REZERVE)}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell padding='none' align="left" className={classes.tableCell}>
                            <DeleteForeverIcon
                              onClick={(event) => AdresSil(event, row.ID)}
                              style={{ color: 'red' }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.altBolum}>
              <Card className={classes.cardScroll} >
                <GenericBulten param={bultenParam} />
              </Card>
            </Grid>
          </Grid>
        </Card>
      </Container>
      <Dialog
        open={openAddressDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseAddressDialog}      >
        <DialogTitle>
          {MalzemeHeader}
        </DialogTitle>
        <DialogContent>
          <Autocomplete
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
              setAddress(newValue.Id);
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={WarehouseAddress}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              if (option.inputValue) {
                return option.inputValue;
              }
              return option.Description;
            }}
            renderOption={(option) => option.Description}
            freeSolo
            renderInput={(params) => (
              <TextField {...params} label="Adres" variant="outlined" />
            )}
          />
          <br />
          <TextField
            id="outlined-number"
            label="Taşınacak Adet"
            fullWidth
            value={AdetDegistir}
            type="number"
            onChange={(e) => setAdetDegistir(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddressChange} color="primary">
            Degİştİr
          </Button>
          <Button onClick={handleCloseAddressDialog} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrlMuadil} />}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}>
        <DialogTitle>
          {SiparisAdetTitle}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                type="number"
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 1,
                  min: 0,
                  max: 999,
                  type: 'number',
                  'aria-labelledby': 'input-slider',
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (

        <Typography>{children}</Typography>

      )}
    </div>
  );
}



TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


export default MaterialSearch;
